import React, { useEffect } from "react";
import { Form } from "semantic-ui-react";

// Hooks and Helpers
import useCustomerInteractionForm from "@common/components/hooks/useCustomerInteractionForm";
import { fetchInteractionOptions } from "@common/components/helpers/CustomerInteraction/fetchInteractionOptions";
import CustomerFormAction from "@common/redux/actions/CustomerFormAction";

// Components
import ToggleComponent from "@common/components/shared/forms/ToggleComponent";
import StandardHiddenInputs from "@common/components/shared/forms/StandardHiddenInputs";
import InteractionForm from "./InteractionForm";
import FormButtonsComponent from "@common/components/shared/forms/FormButtonsComponent";
import RedirectDashboard from "./RedirectDashboard";
import useLogin from "@common/components/hooks/useLogin";
import useIdentityFormModal from "@common/components/hooks/useIdentityFormModal";
import { setComplianceFormDateTime } from "../../helpers/datetime";

const CustomerInteractionForm = ({ config }) => {
  const { methods, isCustomerVulnerable, onSubmit, resetForm } = useCustomerInteractionForm();
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors, isValid },
  } = methods;

  const [{ isDesktop }, setLogin] = useLogin();

  const { isValidPhoto } = useIdentityFormModal();

  useEffect(() => {
    if (!isDesktop) {
      !isDesktop && setLogin({ isInReadMode: false });
      setComplianceFormDateTime(setValue, "Customer Interaction");
    }
    CustomerFormAction.dispatch({ formType: "" });
  }, []);

  return (
    <Form className="form-padding" onSubmit={handleSubmit(onSubmit)}>
      <StandardHiddenInputs />
      {!isDesktop && (
        <ToggleComponent
          control={control}
          name="isCustomerVulnerable"
          handleTrue={fetchInteractionOptions}
          error={errors.isCustomerVulnerable}
        />
      )}
      {isCustomerVulnerable !== null &&
        (isCustomerVulnerable || isDesktop ? (
          <>
            <InteractionForm config={config} />
            <FormButtonsComponent
              isValid={isValid && isCustomerVulnerable && isValidPhoto}
              resetForm={resetForm}
            />
          </>
        ) : (
          <RedirectDashboard />
        ))}
    </Form>
  );
};

export default CustomerInteractionForm;
